import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { type LanTypes, getLanguageCode } from "@src/helpers";

export const KEY = "/api/pep/connection-types";

interface PepConnectionTypes {
  type: string;
  description: string;
  displayText: string;
}

const apiCall = async (language: LanTypes) => {
  const languageCode = getLanguageCode(language);

  const response = await axiosInstance.get<PepConnectionTypes[]>(KEY, {
    headers: { langcode: languageCode },
  });
  return response.data;
};

export const usePepConnectionTypes = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return useQuery({
    queryKey: [KEY, i18n.language],
    queryFn: () => apiCall(i18n.language as LanTypes),
    onError() {
      navigate(`/${i18n.language}/error`);
    },
    staleTime: Infinity,
  });
};
